import axios from "axios";

// Base URL configuration: set REACT_APP_BASE_URL in your env if available
const baseUrl = process.env.REACT_APP_BASE_URL || "";

export type ScanTicketResponse = {
  message?: string;
  validate?: boolean;
  isExpired?: boolean;
  isExtendable?: boolean;
  canExtend?: boolean;
  isPastTicket?: boolean;
  isVisitToday?: boolean;
  requiresExtension?: boolean;
  ticketStatus?: string;
  ticketExpiresAt?: string;
  ticketStartTime?: string;
  expiresInMilliseconds?: number;
  durationSeconds?: number;
  extensionCount?: number;
  serverTime?: string;
  ticket?: {
    id: string;
    first_name?: string;
    last_name?: string;
    ticket_status?: string;
    user_id?: string;
    [key: string]: unknown;
  };
};

export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
};

export const verifyTicketStatusApi = async (data: {
  ticketId: string;
  userTimezone?: string;
}) => {
  try {
    const response = await axios.get(`${baseUrl}/user/payment/scan-ticket`, {
      params: {
        ...data,
        userTimezone: data.userTimezone ?? getUserTimezone(),
      },
    });
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log({ error });
    throw error;
  }
};

export const getGraffitiSprayCansApi = async () => {
  const response = await axios.get(`${baseUrl}/museums/graffiti-spray-cans`);
  return response;
};

export type GraffitiCan = {
  id: string | number;
  name?: string;
  picture?: string;
  available?: boolean;
  status?: string;
  serialNumber: number | 0;
  ticket?: any;
};


